import data from './data'
import methods from './methods'

export default {
  data,
  methods,

  /* route API for professional graduations */
  resourcePath: '/v1/professional/graduations'
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/graduations/resources/index.js